import * as NavActions from '../../../store/orders/nav/orders.nav.actions';

import * as Actions from './orders.filtering.actions';
import * as StateHelper from './orders.filtering.reducer-helper';
import { APP_INITIALIZATION } from '../../core/base-actions';

const initialState = {
  savedFilterViews: [],
  defaultFilterView: StateHelper.getDefaultFilterView(),
  activeFilterViewId: StateHelper.getDefaultFilterView().filterViewId,
  customFilterView: undefined,
  notFilteredByStore: true,
};

export const orderFilter = (state = initialState, action) => {
  const { savedFilterViews, filterViewId, filterView, appliedFilters, propName, propValue, metadata } = action;
  switch (action.type) {
    case Actions.ORDERS_SWITCH_FILTERVIEW: {
      return {
        ...state,
        activeFilterViewId: filterViewId,
      };
    }
    case Actions.ORDERS_AUTOSWITCH_FILTERVIEW_CUSTOM: {
      const newCustomView = StateHelper.createCustomFilterView(filterView, appliedFilters);
      const getQueryCounts = appliedFilters.length === 1 && appliedFilters[0].filterById === 'store';
      return {
        ...state,
        customFilterView: newCustomView,
        activeFilterViewId: newCustomView.filterViewId,
        notFilteredByStore: !getQueryCounts,
      };
    }
    case NavActions.ORDERS_CHANGE_VIEW_SEARCH:
    case Actions.ORDERS_AUTOSWITCH_FILTERVIEW_DEFAULT: {
      // Don't reset filters if they were just applied from a card
      if (state.filterAppliedFromCard) {
        return {
          ...state,
          filterAppliedFromCard: false,
        };
      }
      return {
        ...state,
        activeFilterViewId: state.defaultFilterView.filterViewId,
        defaultFilterView: StateHelper.getDefaultFilterView(),
        customFilterView: undefined,
      };
    }
    case Actions.ORDERS_CHANGE_CUSTOM_FILTERVIEW_PROP: {
      const updatedCustomView = StateHelper.updateCustomViewProp(propName, propValue, state.customFilterView);
      return {
        ...state,
        customFilterView: updatedCustomView,
        notFilteredByStore: true,
      };
    }
    case Actions.ORDERS_CHANGE_FILTERVIEW_PROP: {
      return {
        ...state,
        savedFilterViews: StateHelper.replaceUpdatedFilterView(propName, propValue, filterViewId, state.savedFilterViews),
      };
    }
    case APP_INITIALIZATION: {
      return {
        ...state,
        // As filters have changed over time, there's likely older saved filters that do not confirm with the new functionality. So we sanitize the grid configs here.
        savedFilterViews: StateHelper.sanitizeV3GridConfigs(action.initialData.allGridConfigs),
      };
    }
    case Actions.ORDERS_GET_SAVED_FILTERVIEWS_SUCCESS: {
      return {
        ...state,
        // As filters have changed over time, there's likely older saved filters that do not confirm with the new functionality. So we sanitize the grid configs here.
        savedFilterViews: StateHelper.sanitizeV3GridConfigs(savedFilterViews),
      };
    }
    case Actions.ORDERS_SAVE_NEW_FILTERVIEW_SUCCESS:
    case Actions.ORDERS_SAVE_EXISTING_FILTERVIEW_SUCCESS: {
      return {
        ...state,
        customFilterView: undefined,
        activeFilterViewId: filterView.filterViewId,
        savedFilterViews: [...state.savedFilterViews.filter((view) => view.filterViewId !== filterView.filterViewId), filterView],
      };
    }
    case Actions.ORDERS_DELETE_FILTERVIEW_SUCCESS: {
      return {
        ...state,
        savedFilterViews: state.savedFilterViews.filter((savedView) => savedView.filterViewId !== filterView.filterViewId),
        activeFilterViewId: state.defaultFilterView.filterViewId,
      };
    }
    case Actions.APPLY_FILTER_SET: {
      const newState = StateHelper.mapSavedFilterSetToAppliedFilters(state, appliedFilters, metadata);

      const hasDateFilters = newState.defaultFilterView.appliedFilters.some((filter) => filter.type === 'TYPE_ORDER_DATE_COMPARISON');

      if (metadata?.fromCard && hasDateFilters) {
        const customView = StateHelper.createCustomFilterView(newState.defaultFilterView, newState.defaultFilterView.appliedFilters);
        return {
          ...newState,
          customFilterView: customView,
          activeFilterViewId: customView.filterViewId,
          filterAppliedFromCard: true,
        };
      }

      return {
        ...newState,
        filterAppliedFromCard: metadata?.fromCard === true,
      };
    }
    default:
      return state;
  }
};

export { namespace } from './orders.filtering.reducer.metadata';
